module.exports = __webpack_public_path__ + "static/media/React-Router-01.b548feda.svg";